import React from "react"
import { Icon } from "types/components"

export const SupportIcon: Icon = ({ color, size = 24, ...props }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			width={size}
			viewBox="0 0 22 22"
			{...props}
		>
			<path
				stroke="url(#paint0_linear_6953_41600)"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M3.93 3.93l4.24 4.24m5.66 5.66l4.24 4.24m0-14.14l-4.24 4.24 3.53-3.53M3.93 18.07l4.24-4.24M21 11c0 5.523-4.477 10-10 10S1 16.523 1 11 5.477 1 11 1s10 4.477 10 10zm-6 0a4 4 0 11-8 0 4 4 0 018 0z"
			></path>
			<defs>
				<linearGradient
					id="paint0_linear_6953_41600"
					x1="1"
					x2="23.352"
					y1="1"
					y2="4.114"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor={color ?? "#1753E2"}></stop>
					<stop offset="1" stopColor={color ?? "#F39244"}></stop>
				</linearGradient>
			</defs>
		</svg>
	)
}
